export const TYPE_PARTNER = [
    {
        name: 'In ép',
        value: 'print_partner',
    },
    {
        name: 'May',
        value: 'sewing_partner',
    },
    {
        name: 'Khác',
        value: 'other_partner',
    },
]

export const TYPE_PARTNER_FILTER = [
    {
        name: 'In ép',
        value: 'print_partner',
    },
    {
        name: 'May',
        value: 'sewing_partner',
    },
    {
        name: 'Khác',
        value: 'other_partner',
    }
]